import { getRfq, getRfqById, getBid, postRfq, getBidPrice, extendRfq, cancelRfq, getRfqFilter } from '@/api/rfq.api'

export const FETCH_RFQ = 'FETCH_RFQ'
export const FETCH_RFQ_LOADING = 'FETCH_RFQ_LOADING'
export const FETCH_RFQ_DONE = 'FETCH_RFQ_DONE'
export const FETCH_RFQ_ERROR = 'FETCH_RFQ_ERROR'

export const FETCH_RFQ_FILTER = 'FETCH_RFQ_FILTER'
export const FETCH_RFQ_FILTER_LOADING = 'FETCH_RFQ_FILTER_LOADING'
export const FETCH_RFQ_FILTER_DONE = 'FETCH_RFQ_FILTER_DONE'
export const FETCH_RFQ_FILTER_ERROR = 'FETCH_RFQ_FILTER_ERROR'

export const FETCH_RFQ_BY_ID = 'FETCH_RFQ_BY_ID'
export const FETCH_RFQ_BY_ID_LOADING = 'FETCH_RFQ_BY_ID_LOADING'
export const FETCH_RFQ_BY_ID_DONE = 'FETCH_RFQ_BY_ID_DONE'
export const FETCH_RFQ_BY_ID_ERROR = 'FETCH_RFQ_BY_ID_ERROR'

export const FETCH_BID = 'FETCH_BID'
export const FETCH_BID_LOADING = 'FETCH_BID_LOADING'
export const FETCH_BID_DONE = 'FETCH_BID_DONE'
export const FETCH_BID_ERROR = 'FETCH_BID_ERROR'

export const FETCH_BID_PRICE = 'FETCH_BID_PRICE'
export const FETCH_BID_PRICE_LOADING = 'FETCH_BID_PRICE_LOADING'
export const FETCH_BID_PRICE_DONE = 'FETCH_BID_PRICE_DONE'
export const FETCH_BID_PRICE_ERROR = 'FETCH_BID_PRICE_ERROR'

export const CREATE_RFQ = 'CREATE_RFQ'
export const CREATE_RFQ_LOADING = 'CREATE_RFQ_LOADING'
export const CREATE_RFQ_DONE = 'CREATE_RFQ_DONE'
export const CREATE_RFQ_ERROR = 'CREATE_RFQ_ERROR'

export const EXTEND_RFQ = 'EXTEND_RFQ'
export const EXTEND_RFQ_LOADING = 'EXTEND_RFQ_LOADING'
export const EXTEND_RFQ_DONE = 'EXTEND_RFQ_DONE'
export const EXTEND_RFQ_ERROR = 'EXTEND_RFQ_ERROR'

export const CANCEL_RFQ = 'CANCEL_RFQ'
export const CANCEL_RFQ_LOADING = 'CANCEL_RFQ_LOADING'
export const CANCEL_RFQ_DONE = 'CANCEL_RFQ_DONE'
export const CANCEL_RFQ_ERROR = 'CANCEL_RFQ_ERROR'

export default {
  [FETCH_RFQ] (context, {type, currentPage, perPage}) {
    context.commit(FETCH_RFQ_LOADING)
    return getRfq(currentPage, type, perPage)
      .then((response) => {
        context.commit(FETCH_RFQ_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_RFQ_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_RFQ_FILTER] (context, {payload, perPage}) {
    context.commit(FETCH_RFQ_FILTER_LOADING)
    return getRfqFilter(payload.page, payload.type, perPage, payload.filter, payload.key)
      .then((response) => {
        context.commit(FETCH_RFQ_FILTER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_RFQ_FILTER_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_RFQ_BY_ID] (context, id) {
    context.commit(FETCH_RFQ_BY_ID_LOADING)
    return getRfqById(id)
      .then((response) => {
        context.commit(FETCH_RFQ_BY_ID_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_RFQ_BY_ID_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_BID] (context, id) {
    context.commit(FETCH_BID_LOADING)
    return getBid(id)
      .then((response) => {
        context.commit(FETCH_BID_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_BID_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_BID_PRICE] (context, id) {
    context.commit(FETCH_BID_PRICE_LOADING)
    return getBidPrice(id)
      .then((response) => {
        context.commit(FETCH_BID_PRICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_BID_PRICE_ERROR, error)
        console.error(error)
      })
  },

  [CREATE_RFQ] (context, payload) {
    context.commit(CREATE_RFQ_LOADING)
    return postRfq(payload)
      .then((response) => {
        context.commit(CREATE_RFQ_DONE, response)
        return response
      })
      .catch((error) => {
        context.commit(CREATE_RFQ_ERROR, error)
        console.error(error)
        return error
      })
  },

  [EXTEND_RFQ] (context, payload) {
    context.commit(EXTEND_RFQ_LOADING)
    return extendRfq(payload)
      .then((response) => {
        context.commit(EXTEND_RFQ_DONE, response)
      })
      .catch((error) => {
        context.commit(EXTEND_RFQ_ERROR, error)
        console.error(error)
      })
  },

  [CANCEL_RFQ] (context, {id}) {
    context.commit(CANCEL_RFQ_LOADING)
    return cancelRfq({id})
      .then((response) => {
        return context.commit(CANCEL_RFQ_DONE, response)
      })
      .catch((error) => {
        context.commit(CANCEL_RFQ_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rfq/actions.js